import React, { Component } from 'react';
import { toast } from 'react-toastify';
import Mensagem from '../../common/Mensagem'
import api from '../../services/api';
import { Link } from 'react-router-dom'
import InputMask from 'react-input-mask';
import { validate, format, generate } from 'cnpj';
const { cpf } = require('cpf-cnpj-validator');

class Esqueceu extends Component {
    
    constructor(props){
        super(props);

        this.state = {
            nome:'',           
        }

        this.handleLogin = this.handleLogin.bind(this);
        this.handleEsqueceu = this.handleEsqueceu.bind(this);
        
    }

    async componentDidMount() {

    }

    
    handleLogin = async (event) => {
        event.preventDefault();
        this.props.history.push('/login');
    }     

    handleEsqueceu = async (event) => {
        event.preventDefault();
        
        const { nome } = this.state;
        
        if( !nome ) return toast.error("Nome é obrigatório!");
     
        try {

            const token    = sessionStorage.getItem('token');
        
            
            await api.post('/api/esqueceu',{ nome }, {
                headers: {
                    'x-access-token':token,
                }
            }).then(response => {
                
                this.setState({
                    nome:'',                  
                })
                toast.success("Nova senha enviado por e-mail!")
            }).catch( e => {
                toast.error("O usuário encontra-se desativado.")
            });
            
        } catch (error) {
            toast.error("Ops! Erro ao tentar enviar uma nova senha.")
        }    
    }     

    render() {

        return ( 
            <body className="hold-transition login-page">
                <div className="card">
                    <div className="card-body login-card-body">
                        <div className="login-box">
                            <div className="login-logo">
                                <a href="/login"><b>Ws</b>Lavanderia</a>
                            </div>                    
                        </div>
                        
                        <p className="login-box-msg">Informe o seu e-mail.</p>
                        <form onSubmit={ this.handleEsqueceu }>
                            
                            <div className="input-group mb-3">
                                  
                                <input type="email" className="form-control" name="nome" placeholder="Informe o seu email de acesso" value={ this.state.nome} onChange={ e => this.setState({ nome: e.target.value })}/>
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className="fas fa-envelope"></span>
                                    </div>
                                </div>
                            </div>
                            
                           
                           
                            <div className="row">
                                <div className="col-4">
                                    <button type="submit" className="btn btn-primary btn-block">Enviar</button>
                                </div>                                    
                            </div>
                        </form>      
                        <div className="input-group mb-3">
                            <Link onClick={ this.handleLogin }>Voltar ao Login</Link>
                        </div>
                                               
                    </div>
                </div>
                <Mensagem />
            </body>
        )
    }
}

export default Esqueceu;